import Vue from 'vue'
import axios from 'axios';
import { HTTP } from '@/utils/http-common';
import VueCookies from 'vue-cookies'


export default {
  label_list() {
    return HTTP.get('/account/settings/label/') 
  },
  label_create(label) {
    return HTTP.post('/account/settings/label/', {"name": label})
  },
  getPermissisons(type, name, parent){
    return HTTP.get('/permissions/'+type+'/'+name+'/')
  }
}